module.exports = __webpack_public_path__ + "img/SER-A-2-III.9660e721.png";